import React from 'react';
import {
  Smartphone, Bike, Sofa, Shirt, Dumbbell, Leaf, Puzzle, BookOpen, Tent, Wrench,
} from 'lucide-react';

// Backend slug → frontend slug (backend slugları değiştirilemeyen durumlarda)
const SLUG_ALIASES = {
  vehicles:      'bicycles',
  'real-estate': 'tent',
};

export function resolveSlug(slug) {
  return SLUG_ALIASES[slug] ?? slug;
}

export const CATEGORY_ICONS = {
  electronics: Smartphone,
  bicycles:    Bike,
  furniture:   Sofa,
  clothing:    Shirt,
  sports:      Dumbbell,
  garden:      Leaf,
  toys:        Puzzle,
  books:       BookOpen,
  tent:        Tent,
  services:    Wrench,
};

export function CategoryIcon({ id, className = 'w-6 h-6' }) {
  const Icon = CATEGORY_ICONS[resolveSlug(id)];
  if (!Icon) return null;
  return <Icon className={className} strokeWidth={1.5} />;
}
